<template>
    <!--地图展示-->
    <div>
        <!-- 内容 -->
        <div class="city-content">
            <!-- 内容 -->
            <div class="city-box" id="city-box">

                <Echart id="cityMap" ref="cityMapRef" :height="height" :width="width"></Echart>
                <div class="fullScreen" v-if="!fullFlag">
                    <div class="fullScreen-1" @click="fullScreen()">
                        <svg-icon icon-file-name="u375" style=" font-size: 30px;" />
                        <svg-icon class="fullScreen-2" icon-file-name="u374" style=" font-size: 20px;" />
                    </div>
                </div>
                <div class="fullScreen" v-else>
                    <div class="fullScreen-1" @click="quitFullScreen()">
                        <svg-icon icon-file-name="u15" style=" font-size: 25px;" />
                    </div>
                </div>
                <!-- 标 -->
                <div class="title-div">
                    <div class="title-div-2">
                        <div class="iocn-div icon-color-1"></div>
                        <div>装点</div>
                    </div>
                    <div class="title-div-2">
                        <div class="iocn-div icon-color-2"></div>
                        <div>卸点</div>
                    </div>
                    <div class="title-div-2">
                        <div class="iocn-div icon-color-3"></div>
                        <div>车辆</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import drawMixin from "../../utils/drawMixin";
import Echart from '../../common/echart';
import { loadBMap } from '../../utils/index';
import 'echarts/extension/bmap/bmap';
let ak = "g7T9EGCK8456Rl8Tl5L54Mvuusbd9mTu";
// let myChart;
const CUSTOM_MAP_CONFIG = require('../../common/map/custom_map_config.json');
import { getPlatformCar, querySubitemCheckitem, getSubItemAndCheckItemListByCity } from '../../api/holdMy.js';
export default {
    mixins: [drawMixin],
    data() {
        return {
            height: "785px",
            width: "830px",
            fullFlag: false,
            refreshScaleing: null,   // 刷新定时器
            myChart: null,
            options: {},
            cityCentreCoordList: [
                { name: '厦门', coord: [118.15034, 24.65900], zoom: 11 },
                { name: '福州', coord: [119.36189, 26.12734], zoom: 9.5555 },
                { name: '上海', coord: [121.41757, 31.39018], zoom: 9 },
                { name: '北京', coord: [116.44139, 40.23353], zoom: 9 },
                { name: '温州', coord: [120.71066, 28.00552], zoom: 9 },
                { name: '广州', coord: [113.36760, 23.25031], zoom: 9 },
                { name: '保定', coord: [115.34660, 39.08972], zoom: 9 },
                { name: '佛山', coord: [113.00826, 23.08668], zoom: 10 },
                { name: '宁波', coord: [121.68148, 29.91772], zoom: 9 },
                { name: '杭州', coord: [119.40604, 29.93700], zoom: 9 },
                { name: '郑州', coord: [113.53376, 34.68352], zoom: 10 },
                { name: '济南', coord: [117.05118, 36.70797], zoom: 9 },
                { name: '舟山', coord: [122.19958, 30.05749], zoom: 10 },
                { name: '阿拉善盟', coord: [102.46563, 40.47010], zoom: 7 },
                { name: '长沙', coord: [112.98367, 28.46106], zoom: 9 },
                { name: '泉州', coord: [118.72045, 25.04004], zoom: 9 },
                { name: '南昌', coord: [116.00805, 28.67585], zoom: 10 },
                { name: '莆田', coord: [119.02334, 25.47671], zoom: 10 },
                { name: '惠州', coord: [114.46072, 23.16863], zoom: 9 },
                { name: '重庆', coord: [107.60333, 30.19351], zoom: 8 },
                { name: '临沂', coord: [118.54629, 35.31560], zoom: 9 },
                { name: '贵阳', coord: [106.91800, 26.61215], zoom: 9 },
                { name: '苏州', coord: [120.65217, 31.36502], zoom: 9 },
                { name: '漳州', coord: [117.64953, 24.49564], zoom: 9 },
                { name: '成都', coord: [103.81080, 30.86305], zoom: 9 },
                { name: '深圳', coord: [114.17623, 22.62689], zoom: 11 },
                { name: '武汉', coord: [114.37483, 30.69639], zoom: 9 },
                { name: '青岛', coord: [120.45813, 36.30524], zoom: 9 },
                { name: '宜宾', coord: [104.66693, 28.73697], zoom: 9 },
                { name: '绍兴', coord: [120.58678, 29.78091], zoom: 10 },
                { name: '宁德', coord: [119.48635, 26.83240], zoom: 9 },
                { name: '浙江省', coord: [120.26623, 29.22236], zoom: 8 },
                { name: '湖州', coord: [120.01139, 30.78387], zoom: 10 },
                { name: '辽宁省', coord: [123.43559, 41.84147], zoom: 7 },
                { name: '长春', coord: [125.34470, 43.83754], zoom: 8 },
            ],
            cityCentreCoord: {},
            // 线
            pathData: [],
            // 车辆
            carList: [],
            // 卸点
            projectchecklist: [],
            // 装点
            sysProjectList: [],

        }
    },
    components: { Echart },
    created() {
        // 获取当前城市
        var cityName = localStorage.getItem("cityName");

        this.cityCentreCoord = this.cityCentreCoordList.find(item => item.name === cityName)

        this.refreshScale();
    },
    mounted() {
    },

    beforeDestroy() {
        this.dispose();
    },
    methods: {
        // 获取车辆
        platformCar() {
            var data = {
                'jsonStr': JSON.stringify({
                    name: "城市车辆地图",// 传入用户id
                    userId: "e1320d1ebc224679b22fc1607d03bda7",
                    city: localStorage.getItem("cityName") + "市",
                })
            }
            let carData = [];
            getPlatformCar(data).then(res => {
                if (res.result == 0) {
                    let rows = res.rows;
                    rows.forEach(e => {
                        carData.push([e.longitude, e.latitude, {
                            "carName": e.carName ? e.carName : '', "subItemName": e.subItemName ? e.subItemName : '',
                            "checkItemName": e.checkItemName ? e.checkItemName : '', "distance": e.distance ? e.distance : 0, "carNum": e.carNum ? e.carNum : 0, "lastAddress": e.lastAddress ? e.lastAddress : ''
                        }]);
                    })
                    this.carList = carData;
                    this.$nextTick(() => {
                        this.setOptions();
                    })
                }
            }).catch(error => {
                console.log(error);
            })
        },

        // 获取装点卸点
        getQuerySubitemCheckitem() {
            var data = {
                cityName: this.$route.query.cityName,
                city: this.$route.query.cityName,
            }
            let projectcheckData = [];
            let sysProjectData = [];
            querySubitemCheckitem(data).then(res => {
                if (res.result == 0) {
                    let userdata = res.userdata;
                    // 卸点
                    let projectchecklist = userdata.projectchecklist;
                    projectchecklist.forEach(e => {
                        projectcheckData.push([e.longitude, e.latitude, { "usageCount": e.usageCount ? e.usageCount : 0, "checkItemName": e.checkItemName ? e.checkItemName : '' }]);
                    })
                    this.projectchecklist = projectcheckData;
                    // 装点
                    let sysProjectList = userdata.sysProjectList;
                    sysProjectList.forEach(e => {
                        sysProjectData.push([e.longitude, e.latitude, {
                            "name": e.name ? e.name : '', "loadingAvgWaitTime": e.loadingAvgWaitTime ? e.loadingAvgWaitTime : 0,
                            "loadingAvgWaitCarCount": e.loadingAvgWaitCarCount ? e.loadingAvgWaitCarCount : 0, "todaytotalTransportOrderCount": e.todaytotalTransportOrderCount ? e.todaytotalTransportOrderCount : 0
                        }]);
                    })
                    this.sysProjectList = sysProjectData;
                    this.$nextTick(() => {
                        this.setOptions();
                    })
                }
            }).catch(error => {
                console.log(error);
            })
        },

        subItemAndCheckItemListByCity() {
            var data = {
                cityName: localStorage.getItem("cityName") + "市"
            }
            let dataList = [];
            getSubItemAndCheckItemListByCity(data).then(res => {
                if (res.result == 0) {
                    let data = res.rows;
                    data.forEach(e => {
                        if (e.startLongitude && e.startLatitude && e.endLongitude && e.endLatitude) {
                            if (e.startLongitude != 0 && e.startLatitude != 0 && e.endLongitude != 0 && e.endLatitude != 0) {
                                let coords = [];
                                // 起点
                                coords.push([e.startLongitude ? e.startLongitude : '', e.startLatitude ? e.startLatitude : ''])
                                // 总点
                                coords.push([e.endLongitude ? e.endLongitude : '', e.endLatitude ? e.endLatitude : '']);
                                dataList.push({ coords })
                            }

                        }

                    });
                    this.pathData = dataList;
                    this.$nextTick(() => {
                        this.setOptions();
                    })
                }
            }).catch(error => {
                console.log(error);
            })
        },
        // 刷新规模数据 30 * 57 * 1000 半个小时
        async refreshScale() {
            this.init();
            this.platformCar();
            this.getQuerySubitemCheckitem();
            this.subItemAndCheckItemListByCity();
            this.$nextTick(() => {
                this.setOptions();
            })
            this.refreshScaleing = setInterval(() => {
                this.platformCar();
                this.getQuerySubitemCheckitem();
                this.subItemAndCheckItemListByCity();
            }, 1000 * 60 * 30)
        },

        // 销毁echarts
        dispose() {
            if (this.myChart != null && this.myChart != '' && this.myChart != undefined) {
                this.myChart.dispose(); //销毁
            }
        },

        // 初始化地图
        init() {
            const that = this;
            loadBMap(ak).then(res => {
                that.myChart = this.$echarts.init(document.getElementById('cityMap'));
                that.options = {
                    bmap: {
                        center: this.cityCentreCoord.coord,
                        zoom: this.cityCentreCoord.zoom,
                        roam: true, //鼠标拖拽和方法缩小
                        enableDblclickZoom: false,
                        displayOptions: {
                            building: true
                        },
                        mapStyle: { style: 'midnight' },// 深色模式
                    },
                }
                that.myChart.setOption(that.options);
                let map = that.myChart.getModel().getComponent("bmap").getBMap();

                map.setMapStyle({ styleJson: CUSTOM_MAP_CONFIG, });
                // map.setZoom(9.5);
                /**
                 *
                 * 处理缩放偏移量变化的问题
                 */
                // 临时存储地图中心点经度和纬度
                let center_lng = 0;
                let center_lat = 0;
                // 监听地图缩放开始事件 lng表示经度，lat表示纬度
                map.addEventListener("zoomstart", function (e) {
                    center_lng = map.getCenter().lng;
                    center_lat = map.getCenter().lat;
                });
                // 监听地图缩放结束事件 lng表示经度，lat表示纬度
                map.addEventListener("zoomend", function (e) {
                    map.centerAndZoom(
                        new res.Point(center_lng, center_lat),
                        map.getZoom()
                    );
                });
                that.setBMap(res, map);
            })
        },

        // 设置数据
        setOptions() {
            const that = this;
            // 配置option
            this.options = {
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    // 线
                    {
                        type: "lines",
                        coordinateSystem: "bmap",
                        zlevel: 15,

                        effect: {
                            show: true,
                            constantSpeed: 30,
                            symbol: "arrow",
                            symbolSize: 8,
                            trailLength: 0,
                        },
                        lineStyle: {
                            normal: {
                                color: "rgb(121,234,240)",
                                width: 2,
                                opacity: 1,
                                curveness: 0.2,
                            },
                        },
                        data: this.pathData
                    },



                    // 卸点
                    {
                        type: 'effectScatter',
                        coordinateSystem: 'bmap',
                        symbolSize: 8,
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke',
                        },
                        itemStyle: {
                            normal: {
                                shadowBlur: 8,
                                shadowColor: 'rgb(0 255 0 / 49%)',
                                shadowOffsetY: 3,
                                color: 'rgb(0 255 0 / 49%)'
                            }
                        },
                        tooltip: {
                            show: true,
                            trigger: 'item',
                            formatter: (params) => {
                                let info = params.data[2];
                                return `
                                    <div  style="width: 150px;">
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%;text-align: left;">名称：</div><div style="width: 80%;text-align: right;">${info.checkItemName}</div></div>
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%; text-align: left;">卸土车数：</div><div style="width: 80%;text-align: right;">${info.usageCount}</div></div>
									</div>
								`;
                            }
                        },

                        data: this.projectchecklist
                    },
                    // 装点
                    {
                        type: 'effectScatter',
                        coordinateSystem: 'bmap',
                        symbolSize: 8,
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke',
                        },
                        itemStyle: {
                            color: 'rgb(255 64 64 / 64%)',
                            shadowBlur: 8,
                            shadowOffsetY: 3,
                            shadowColor: 'rgb(255 64 64 / 49%)'
                        },

                        tooltip: {
                            show: true,
                            trigger: 'item',
                            formatter: (params) => {
                                let info = params.data[2];
                                return `
                                    <div  style="width: 150px;">
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%;text-align: left;">名称：</div><div style="width: 80%;text-align: right;">${info.name}</div></div>
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%;text-align: left;">平均等待车辆：</div><div style="width: 80%;text-align: right;">${info.loadingAvgWaitCarCount}</div></div>
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%;text-align: left;">平均等待时间：</div><div style="width: 80%;text-align: right;">${info.loadingAvgWaitTime}</div></div>
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%; text-align: left;">今日运单数：</div><div style="width: 80%;text-align: right;">${info.todaytotalTransportOrderCount}</div></div>

									</div>
								`;
                            }
                        },
                        data: this.sysProjectList
                    },
                    // 车辆
                    {
                        type: 'scatter',
                        coordinateSystem: 'bmap',
                        symbolSize: 12,
                        hoverAnimation: true,
                        itemStyle: {
                            normal: {
                                shadowBlur: 12,
                                shadowColor: 'rgb(25, 100, 150)',
                                shadowOffsetY: 5,
                                color: new that.$echarts.graphic.RadialGradient(0.4, 0.3, 1, [{
                                    offset: 0,
                                    color: 'rgb(30 144 255 )'
                                }, {
                                    offset: 1,
                                    color: 'rgb(30 144 255)'
                                }])
                            }
                        },
                        tooltip: {
                            show: true,
                            trigger: 'item',
                            formatter: (params) => {
                                let info = params.data[2];
                                return `
									<div  style="width: 190px;">
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%;text-align: left;">名称：</div><div style="width: 80%;text-align: right;">${info.carName}</div></div>
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%; text-align: left;">装点：</div><div style="width: 80%;text-align: right;">${info.subItemName}</div></div>
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%;text-align: left;">卸点：</div><div style="width: 80%;text-align: right;">${info.checkItemName}</div></div>
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%; text-align: left;">运距：</div><div style="width: 80%;text-align: right;">${info.distance}4</div></div>
                                        <div style=" display: flex;align-items: center;"><div style="width: 33%;text-align: left;">当前位置：</div><div style="width: 75%;text-align: right;overflow:hidden">${info.lastAddress}</div></div>
                                        <div style=" display: flex;align-items: center;"><div style="width: 20%; text-align: left;">今天：</div><div style="width: 80%;text-align: right;">${info.carNum}</div></div>
									</div>
								`;
                            }
                        },

                        data: this.carList
                    }
                ]
            }
            that.myChart.setOption(that.options);
        },

        // 设置城市覆盖物
        setBMap(BMap, map) {
            var bdary = new BMap.Boundary();
            bdary.get(this.cityCentreCoord.name, function (rs) {
                // map.clearOverlays();//清除地图覆盖物
                // 获取行政区域数量
                var count = rs.boundaries.length;
                var pointArray = [];
                for (var i = 0; i < count; i++) {
                    var ply = new BMap.Polygon(rs.boundaries[i], { strokeWeight: 3, strokeColor: '#01faf3', fillOpacity: '0.2' });
                    map.addOverlay(ply);
                    pointArray = pointArray.concat(ply.getPath());
                }
                //调整视野
                // map.setViewport(pointArray);
            });

        },

        // 地图全屏
        fullScreen() {
            this.fullFlag = true;
            let element = document.getElementById("city-box");
            this.dispose();
            this.width = window.screen.width + 'px';
            this.height = window.screen.height + 'px';
            // 一些浏览器的兼容性
            if (element.requestFullScreen) {
                // HTML W3C 提议
                element.requestFullScreen();
            } else if (element.msRequestFullscreen) {
                // IE11
                element.msRequestFullScreen();
            } else if (element.webkitRequestFullScreen) {
                // Webkit (works in Safari5.1 and Chrome 15)
                element.webkitRequestFullScreen();
            } else if (element.mozRequestFullScreen) {
                // Firefox (works in nightly)
                element.mozRequestFullScreen();
            }

            this.init();
            this.platformCar();
            this.getQuerySubitemCheckitem();
            this.subItemAndCheckItemListByCity();
            this.$nextTick(() => {
                this.setOptions();
            })
        },

        // 地图退出全屏
        quitFullScreen() {
            this.fullFlag = false;
            let element = document.getElementById("city-box");
            this.dispose();
            this.width = "830px";
            this.height = "785px";
            // 退出全屏
            if (element.requestFullScreen) {
                document.exitFullscreen();
            } else if (element.msRequestFullScreen) {
                this.width = "830px";
                this.height = "785px";
                document.msExitFullscreen();
            } else if (element.webkitRequestFullScreen) {
                this.width = "830px";
                this.height = "785px";
                document.webkitCancelFullScreen();
            } else if (element.mozRequestFullScreen) {
                this.width = "830px";
                this.height = "785px";
                document.mozCancelFullScreen();
            }
            this.init();
            this.platformCar();
            this.getQuerySubitemCheckitem();
            this.subItemAndCheckItemListByCity();
            this.$nextTick(() => {
                this.setOptions();
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.city-content {
    height: 785px;
    width: 830px;
}

.city-box {
    position: relative;
}

.title-div {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    position: absolute;
    right: 0;
    bottom: 1%;
    width: 322px;
    height: 39px;
    background: inherit;
    background-color: rgba(14, 82, 126, 0.2980392156862745);
    border: none;
    border-radius: 19px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: 'Arial', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: #FFFFFF;

    .title-div-2 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        margin: auto;
    }

    .iocn-div {
        width: 20px;
        height: 20px;
        background-color: red;
        border-radius: 50%;
        margin-right: 10px;
    }

    .icon-color-1 {
        background-color: rgb(255 64 64 / 64%);
    }

    .icon-color-2 {
        background-color: rgb(0 255 0 / 49%);
    }

    .icon-color-3 {
        background-color: rgb(30 144 255 / 71%);
    }



}

.fullScreen {
    position: absolute;
    top: 1%;
    right: 1%;
    cursor: pointer;

    .fullScreen-1 {
        width: 30px;
        height: 30px;


    }

    .fullScreen-2 {
        position: absolute;
        top: 15%;
        left: 18%;
    }
}

::v-deep .BMap_cpyCtrl {
    display: none;
}

::v-deep .anchorBL {
    display: none;
}

.tooltip-div {
    display: flex;
    align-items: center;
}

/* 隐藏全屏按钮 */
.full-screen-button {
    display: none !important;
}
</style>